<template>
  <div class="template agenda-view-wrapper">
    <AgendaParams />
    <AgendaDatas />
  </div>
</template>

<script setup>
import AgendaParams from "@follaw-fr/components/agenda/templates/AgendaParams.vue";
import AgendaDatas from "@follaw-fr/components/agenda/templates/AgendaDatas.vue";
import { useAgendaStore } from "@follaw-fr/stores/agenda";

const store = useAgendaStore();

store.selectedFilters.from = 0;
store.fetchEvents();
</script>
